/**
 * Semantic Spacing Tokens
 *
 * Use these for all padding, margin, and gap values.
 * p="md" = 16px, gap="xl" = 24px
 */
const semanticSpacing = {
  none: "0px",
  "3xs": "2px",
  "2xs": "4px",
  xs: "8px",
  sm: "12px",
  md: "16px", // Default spacing
  lg: "20px",
  xl: "24px",
  "2xl": "32px",
  "2.5xl": "36px",
  "3xl": "40px",
  "4xl": "48px",
  "5xl": "64px",
  "6xl": "80px",
  "7xl": "96px",
};

export default semanticSpacing;

// Chakra v3 formatted spacing tokens
export const spacingTokens = Object.entries(semanticSpacing).reduce(
  (acc, [key, val]) => {
    acc[key] = { value: val };
    return acc;
  },
  {} as Record<string, { value: string }>
);
